import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ApiGet } from '../../helper/axiosFunctions';
import { commonToast } from '../../helper/Toast';
import Loading from '../Loading';

export default function MaterialQuestions({ data }) {
    const { t } = useTranslation();
    const [cardLoading, setCardLoading] = useState(false);
    const [cards, setCards] = useState([])

    const getCards = async () => {
        setCardLoading(true);
        try {
            const response = await ApiGet(`/contents/decks/${data?.deckId}/cards`);
            setCards(response?.data || []);
        } catch (error) {
            commonToast(error?.data?.error || error?.message, "error");
        } finally {
            setCardLoading(false);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getCards();
    }, []);

    return (
        <>
            {cardLoading ? (
                <div className="my-20">
                    <Loading size="10" />
                </div>
            ) : <div className="grid grid-cols-4 lg:grid-cols-2 md:!grid-cols-1 gap-5 my-5">
                {cards.map((item, index) => {
                    const questionImage = item?.question?.parts?.find(
                        (part) => (part.contentType.includes("image") || part.contentType.includes("unknown"))
                    )?.contentBody;
                    const question = item?.question?.parts?.find(
                        (part) => (part.contentType.includes("text"))
                    )?.contentBody;
                    let answerSection = null;
                    if (item?.answerType === "TEST" && item.answers?.[0]?.parts?.length) {
                        answerSection = (
                            <ul className="pl-4 line-clamp-4 base-text">
                                {item?.answers?.[0]?.parts
                                    .filter(
                                        (part) =>
                                            !part.contentType.includes("image") &&
                                            !part.contentType.includes("video") &&
                                            !part.contentType.includes("audio")
                                    )
                                    .map((part, idx) => (
                                        <li key={idx} className="base-text">
                                            {part.contentBody}
                                        </li>
                                    ))}
                            </ul>
                        );
                    } else if (item.answerType === "INPUT" && item.answers?.length) {
                        answerSection = (
                            <ul className="pl-4 line-clamp-4 base-text border-t space-y-1 pt-2">
                                {item.answers.map((answer, idx) => (
                                    answer?.parts?.length > 0 ?
                                        answer.parts
                                            .filter((part) => part.contentType.includes("text"))
                                            .map((part, idx) => (
                                                <li key={idx} className="base-text">
                                                    {part.contentBody}
                                                </li>
                                            ))
                                        : null
                                ))}
                            </ul>
                        );
                    } else {
                        const answer = item?.answers?.[0]?.parts?.find(
                            (part) => (part.contentType.includes("text"))
                        )?.contentBody;
                        answerSection = (
                            <p className="base-text h-20">
                                {answer?.length > 100 ? answer?.slice(0, 100) + ' ...' : <div dangerouslySetInnerHTML={{ __html: answer }}></div> || 'No answers provided.'}
                            </p>
                        );
                    }

                    return (
                        <div
                            key={index + 1}
                            className="rounded-xl relative border shadow-md p-4  bg-white"
                        >
                            <h2 className="text-lg mb-2 line-clamp-2 h-10">
                                {item?.cardName || "-"}
                            </h2>
                            <h2 className="text-base mb-2 line-clamp-2">
                                {question || "N/A"}
                            </h2>
                            <div className="max-h-[300px] overflow-hidden">
                                {questionImage &&
                                    <div className="pb-10">
                                        <img
                                            src={questionImage}
                                            alt={'questionImage' + (index + 1)}
                                            loading="lazy"
                                            className="size-[150px] object-cover rounded-lg border text-sm"
                                        />
                                    </div>
                                }
                                {answerSection}
                            </div>
                        </div>
                    );
                })}
            </div>}

        </>
    )
}
